import { useRef, useEffect, useMemo } from "react"
import { debounce, DebouncedFunc } from "lodash"

// TODO: See if this can be used to replace other debouncing functions
export default function useDebouncedCallback<T extends (...args: unknown[]) => unknown>(
  callback: T,
  delay: number,
): DebouncedFunc<T> {
  const callbackRef = useRef<T>(callback)

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  return useMemo(
    () => debounce((...args: Parameters<T>) => callbackRef.current(...args), delay),
    [delay],
  )
}
